export default [
    {
        path: '/fo/solution',
        name: '솔루션',
        component: () => import('@/page/solution/SolutionContainer.vue'),
    },
    {
        /* 솔루션 중지 */
        path: '/fo/solutionPause',
        name: '일시정지',
        component: () => import('@/page/solution/SolutionPause.vue'),
    },
    {
        /* 솔루션 완료 */
        path: '/fo/solutionComplete',
        name: '미션완료',
        component: () => import('@/page/solution/SolutionComplete.vue'),
        meta:{
            isHideBack: true,
        }
    },
    {
        /* 광장에 남기기 */
        path: '/fo/solutionRegister',
        name: '광장에 남가기',
        component: () => import('@/page/solution/SolutionRegister.vue'),
        meta:{
            isHideBack: true,
            headerTitle: '광장에 남기기',
        }
    },
    {
        /* 솔루션 팝업 */
        path: '/fo/SolutionModal',
        name: '솔루션 팝업',
        component: () => import('@/page/solution/SolutionModal.vue'),
        meta:{
            isHideBack: true,
            headerTitle: '솔루션',
        }
    },
    /* 솔루션 도서관 */{
        path: '/fo/solution/library/:type',
        name: '솔루션 도서관상세',
        component: () => import('@/page/library/LibraryView.vue'),
        meta:{
            isHideHeader: true,
            headerTitle: '',
            // isHeart: true,
        }
    }
]
